/**
 * Created by carlhaynes on 9/28/17.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {GotoPage} from "../App";
import { Breadcrumb } from 'react-bootstrap';
import {withRouter} from 'react-router-dom'
import { Row } from 'react-bootstrap';
import ScrollToTopOnMount from "../Components/ScrollToTopOnMount"

class Crummy extends Component {


  render() {

    const paths = this.props.paths.map((item) =>
      <Breadcrumb.Item href={item.path} onClick={(e) => GotoPage(e, this.props, item.path)} key={item.name}>
        {item.name}
      </Breadcrumb.Item>
    );

    let page = "";
    if (this.props.page) {
      page = <Breadcrumb.Item active>
        {this.props.page}
      </Breadcrumb.Item>
    }


    return (
      <Row>
        <ScrollToTopOnMount/>
        <div style={{paddingTop: '30px'}}>
          <Breadcrumb>
          {paths}
          {page}
          </Breadcrumb>
        </div>
      </Row>
    );
  }

}

Crummy.propTypes = {
  paths: PropTypes.array.isRequired,
  page: PropTypes.string
};

export default withRouter(Crummy);





// WEBPACK FOOTER //
// ./src/Components/Crummy.jsx